import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter, Route, Routes, Navigate, useLocation } from 'react-router-dom';
import { Provider } from 'react-redux';
import { store } from './admin/store';
import CarnivalIntro from './pages/carnival/CarnivalIntro';
import CarnivalHome from './pages/carnival/CarnivalHome';
import CarnivalPlay from './pages/carnival/CarnivalPlay';

// Redirect to the intro but keep ?otp=…&role=… / ?demo=… so a refresh can log in again.
function ToIntro() {
  const { search } = useLocation();
  return <Navigate to={{ pathname: '/carnival', search }} replace />;
}

function App() {
  return (
    <Provider store={store}>
      <Routes>
        <Route index element={<ToIntro />} />
        <Route path="/login" element={<ToIntro />} />
        <Route path="/carnival" element={<CarnivalIntro />} />
        <Route path="/carnival/games" element={<CarnivalHome />} />
        <Route path="/carnival/play/:gameKey" element={<CarnivalPlay />} />
        <Route path="*" element={<ToIntro />} />
      </Routes>
    </Provider>
  );
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>
);

reportWebVitals();
